import { ScorpionSolitaireView } from "./scorpionSolitaireView";
import { ScorpionSolitaire } from "../Models/Scorpion/scorpionSolitaire";
import { BaseViewConnector, ViewConnector } from "./viewConnector";

export const viewConnectors : (BaseViewConnector)[] = [
    new ViewConnector(ScorpionSolitaire, ScorpionSolitaireView)
];